export const AuthoringAmendsType = Object.freeze({
    AUTHORING_AMENDS: "authoring-amends",
})

export function isAuthoringAmendsType(value) {
    return Object.values(AuthoringAmendsType).includes(value)
}
